<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 text-center">
      <div class="alert alert-success text-center p-2 mx-3 rounded-pill"> {{ message }} </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "successAlert",
  props: {
    message: "",
  }
}
</script>